import { useContext } from "react";
import { ShowContent } from "../../../components";
import AuthContext from "../../../context/AuthContext";
import { PullingReportClient } from "./PullingReportClient";
import { PullingReportAdmin } from "./PullingReportAdmin";

export const PullingReportPage = () => {
  const { idRole, isLoading } = useContext(AuthContext);

  const content =
    idRole === 3 ? <PullingReportClient /> : <PullingReportAdmin />;

  return <ShowContent error={""} isLoading={isLoading} content={content} />;
};
